import ClosedCampaignPartial from "../../partials/campaign/closed-campaign.partial";

export default function ClosedCampaignScreen() {
  return <ClosedCampaignPartial />;
}
